import React, { useState } from 'react';

import { CheckCircle, Cancel, Edit } from '@mui/icons-material';
import { useRecordContext } from 'react-admin';
import { DecisionTypes } from 'src/constants/choices/ach.transfers.choices';
import { SearchTransferItem } from 'src/models';

import Colors from '../../constants/colors';
import Styles from '../../constants/styles';

import ActionModals from './actionModals';

const Actions = ({ bodyStyle = {} }: any) => {
  const record = useRecordContext();
  const [curElement, setCurElement] = useState<SearchTransferItem>();
  const [decideModalOpen, setDecideModalOpen] = useState<boolean>(false);
  const [activeType, setActiveType] = useState<DecisionTypes>(DecisionTypes.FIRM_APPROVE);

  const repApproveHandle = (data: any) => {
    setCurElement(data);
    setActiveType(DecisionTypes.REP_APPROVE);
    setDecideModalOpen(true);
  };

  const firmApproveHandle = (data: any) => {
    setCurElement(data);
    setActiveType(DecisionTypes.FIRM_APPROVE);
    setDecideModalOpen(true);
  };

  const rejectHandle = (data: any) => {
    setCurElement(data);
    setActiveType(DecisionTypes.REJECT);
    setDecideModalOpen(true);
  };

  const cancelHandle = (data: any) => {
    setCurElement(data);
    setActiveType(DecisionTypes.CANCEL);
    setDecideModalOpen(true);
  };

  const editHandle = (data: any) => {
    setCurElement(data);
    setActiveType(DecisionTypes.EDIT);
    setDecideModalOpen(true);
  };

  const ActionModalsContent = () => {
    return curElement ? (
      <ActionModals
        curElement={curElement}
        modalOpen={decideModalOpen}
        setModalOpen={setDecideModalOpen}
        type={activeType}
      />
    ) : (
      <></>
    );
  };

  const getItems = (state: string) => {
    switch (state) {
      case 'Unknown':
      case 'Void':
        return <></>;
      case 'PendingRepCreateApproval':
        return (
          <>
            <button
              className='customButton'
              style={Styles.achRelationship.menuItem}
              onClick={() => repApproveHandle(record)}>
              <CheckCircle style={{ color: Colors.SUCCESS }} />
              <span style={{ color: Colors.SUCCESS_DARK, paddingLeft: 5 }}>REP APPROVE</span>
            </button>
            <button
              className='customButton'
              style={Styles.achRelationship.menuItem}
              onClick={() => rejectHandle(record)}>
              <Cancel style={{ color: Colors.DANGER }} />
              <span style={{ color: Colors.DANGER_DARK, paddingLeft: 5 }}>REJECT</span>
            </button>
            <button className='customButton' style={Styles.achRelationship.menuItem} onClick={() => editHandle(record)}>
              <Edit style={{ color: Colors.LIGHTER_MY_IPO_BLUE }} />
              <span style={{ color: Colors.MY_IPO_BLUE, paddingLeft: 5 }}>EDIT</span>
            </button>
          </>
        );
      case 'PendingFirmCreateApproval':
        return (
          <>
            <button
              className='customButton'
              style={Styles.achRelationship.menuItem}
              onClick={() => firmApproveHandle(record)}>
              <CheckCircle style={{ color: Colors.SUCCESS }} />
              <span style={{ color: Colors.SUCCESS_DARK, paddingLeft: 5 }}>FIRM APPROVE</span>
            </button>
            <button
              className='customButton'
              style={Styles.achRelationship.menuItem}
              onClick={() => rejectHandle(record)}>
              <Cancel style={{ color: Colors.DANGER }} />
              <span style={{ color: Colors.DANGER_DARK, paddingLeft: 5 }}>REJECT</span>
            </button>
            <button className='customButton' style={Styles.achRelationship.menuItem} onClick={() => editHandle(record)}>
              <Edit style={{ color: Colors.LIGHTER_MY_IPO_BLUE }} />
              <span style={{ color: Colors.MY_IPO_BLUE, paddingLeft: 5 }}>EDIT</span>
            </button>
          </>
        );
      case 'Approved':
      case 'Requested':
      case 'Pending':
      case 'PendingPrinting':
      case 'Postponed':
      case 'Pending':
        return (
          <>
            <button
              className='customButton'
              style={Styles.achRelationship.menuItem}
              onClick={() => cancelHandle(record)}>
              <Cancel style={{ color: Colors.DANGER }} />
              <span style={{ color: Colors.DANGER_DARK, paddingLeft: 5 }}>CANCEL</span>
            </button>
            <button className='customButton' style={Styles.achRelationship.menuItem} onClick={() => editHandle(record)}>
              <Edit style={{ color: Colors.LIGHTER_MY_IPO_BLUE }} />
              <span style={{ color: Colors.MY_IPO_BLUE, paddingLeft: 5 }}>EDIT</span>
            </button>
          </>
        );

      case 'FundsPosted':
      case 'FundsHeld':
      case 'SentToBank':
      case 'Returned':
      case 'StopPayment':
      case 'CreateRejected':
      case 'Rejected':
      case 'Complete':
      case 'Canceled':
      default:
        return (
          <>
            <button className='customButton' style={Styles.achRelationship.menuItem} onClick={() => editHandle(record)}>
              <Edit style={{ color: Colors.LIGHTER_MY_IPO_BLUE }} />
              <span style={{ color: Colors.MY_IPO_BLUE, paddingLeft: 5 }}>EDIT</span>
            </button>
          </>
        );
    }
  };

  if (record) {
    return (
      <>
        <div style={{ ...Styles.defaults.alignCenter, ...bodyStyle }}>{getItems(record.state)}</div>
        <ActionModalsContent />
      </>
    );
  } else return <></>;
};
export default Actions;
